export default __webpack_public_path__ + "static/media/General_03_02.45b5e869.jpg";